
__webpack_require__.remotesLoadingData = { chunkMapping: {"836":["82083"]}, moduleIdToRemoteDataMapping: {"82083":{"shareScope":"default","name":"./Widgets","externalModuleId":53993,"remoteName":"frontend_contacts"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
